import { render } from "./NestedModifierSet.vue?vue&type=template&id=588a8f46&scoped=true"
import script from "./NestedModifierSet.vue?vue&type=script&lang=js"
export * from "./NestedModifierSet.vue?vue&type=script&lang=js"

import "./NestedModifierSet.vue?vue&type=style&index=0&id=588a8f46&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588a8f46"]])

export default __exports__